// extracted by mini-css-extract-plugin
module.exports = {"shell":"Layout_shell__2x0ex","main":"Layout_main__1dFZc"};